export const getPageFrameKey = (
  componentId: string,
  pageIndex: number
) => `${componentId}/${pageIndex}`;
